var map = {
	"./ADRIVE_16.png": 41,
	"./ADRIVE_32.png": 42,
	"./ASK.png": 43,
	"./BIOS.png": 44,
	"./CDRIVE_16.png": 45,
	"./CDRIVE_32.png": 46,
	"./CDROM_32.png": 47,
	"./CDSAMPLE_16.png": 48,
	"./CDSAMPLE_32.png": 49,
	"./CLOSE.png": 50,
	"./CUR_STD.png": 51,
	"./DIR_CLOSED_32.png": 52,
	"./DIR_OPEN.png": 53,
	"./DOCS.png": 54,
	"./ENERSTAR.png": 55,
	"./ERROR.png": 56,
	"./EXEC_16.png": 57,
	"./EXEC_32.png": 58,
	"./EXPLORER_16.png": 59,
	"./FIND.png": 60,
	"./GRIP.png": 61,
	"./HELP.png": 62,
	"./HTML.png": 63,
	"./IEBACK.png": 64,
	"./IEBACK_A.png": 65,
	"./IEFAVS.png": 66,
	"./IEFAVS_A.png": 67,
	"./IEFWD.png": 68,
	"./IEFWD_A.png": 69,
	"./IEHOME.png": 70,
	"./IEHOME_A.png": 71,
	"./IEICON.png": 72,
	"./IERFSH.png": 73,
	"./IERFSH_A.png": 74,
	"./IESRCH.png": 75,
	"./IESRCH_A.png": 76,
	"./IESTOP.png": 77,
	"./IESTOP_A.png": 78,
	"./IEXPLORE_16.png": 79,
	"./IEXPLORE_32.png": 80,
	"./IE_BG.png": 81,
	"./INETNEWS.png": 82,
	"./INFO.png": 83,
	"./MAXIMIZE.png": 84,
	"./MINIMIZE.png": 85,
	"./MY_PC_16.png": 86,
	"./MY_PC_32.png": 87,
	"./NOTEPAD_16.png": 88,
	"./NOTEPAD_32.png": 89,
	"./PROGMENU.png": 90,
	"./PROGRAMS.png": 91,
	"./RECYCLED_16.png": 92,
	"./RECYCLED_32.png": 93,
	"./RESTORE.png": 94,
	"./RUN.png": 95,
	"./SETTINGS.png": 96,
	"./SHORTCUT.png": 97,
	"./SHUTDOWN.png": 98,
	"./SHUTVEIL.png": 99,
	"./SND.png": 100,
	"./START.png": 101,
	"./STARTARA.png": 102,
	"./STARTARI.png": 103,
	"./STARTBAN.png": 104,
	"./TASKACTV.png": 105,
	"./TEXTFILE_16.png": 106,
	"./TEXTFILE_32.png": 107,
	"./WARNING.png": 108,
	"./WINFILE_32.png": 109
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 40;


//////////////////
// WEBPACK FOOTER
// ./src/walleris/images nonrecursive \.png$
// module id = 40
// module chunks = 0